import { Box, Image } from "@chakra-ui/react";
import React from "react";
import StudentWrapper from "../../Auth/StudentWrapper";
import Loading from "../../UI/loading";
import Navbar from "./navbar";

const Layout = ({ children, color, bg, register = true, type, isLoading }) => {
  return (
    <StudentWrapper roles={["Student"]}>
      <Box
        w="100%"
        h="100%"
        minH="100vh"
        className="public"
        overflowX="hidden"
        justifyContent="space-between"
      >
        <Image
          src={require("../../../assets/Vector 6.jpg")}
          position="absolute"
          zIndex="-1"
          left="-80px"
          display={{ base: "none", md: "block" }}
        />
        <Box h="7%" w="100%">
          <Navbar color={color} bg={bg} register={register} type={type} />
        </Box>
        <Image
          src={require("../../../assets/Vector.jpg")}
          position="absolute"
          right="-80px"
          top="20%"
          zIndex="-1"
          display={{ base: "none", md: "block" }}
        />

        {isLoading ? <Loading /> : <Box pb="40px">{children}</Box>}
      </Box>
    </StudentWrapper>
  );
};

export default Layout;
